// extracted by mini-css-extract-plugin
export default {"comments":"PhotoComments_comments__UMX7s","single":"PhotoComments_single__6lm-J"};